// extracted by mini-css-extract-plugin
export default {"additionalText":"FootnoteDetails_additionalText__brhyx"};